import { Subscription, merge } from 'rxjs';
import { Component, Input, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormArray } from '@angular/forms';
import { ADDRESS3_GROUPED, ADDRESS3_LIST } from '@app/config/address.data';
import { LEVEL_LIST } from '@app/config/job-level.enum';
import { POSITION_GROUPED, POSITION_LIST, POSITION_CATEGORY_LIST } from '@app/config/position.data';
import { GenericSearchComponent } from '@app/helpers/generic-search-component';
import { JobService } from '@app/services/job.service';
import { UserService } from '@app/services/user.service';
import { status_code } from 'functions/src/help/status-query';
import { FormGroupCheckboxMultiAccordionComponent } from '../form-group/form-group-checkbox-multi-accordion/form-group-checkbox-multi-accordion.component';
import { PositionIndexPipe } from '@app/pipes/position-index.pipe';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'job-search-form',
  templateUrl: './job-search-form.component.html',
  styleUrls: ['./job-search-form.component.css']
})
export class JobSearchFormComponent extends GenericSearchComponent {

  @Input() filterNextSeason: boolean = true;
  @Input() splitBySeason: boolean = false;
  @Input() showUniqueInstitutions: boolean = false;
  @Input() showCategory: boolean = true;
  @Input() category: string = undefined;
  @Input() position: string = undefined;
  @Input() loadPreferences: boolean = false;

  @ViewChild('filterAddress3') filterAddress3: FormGroupCheckboxMultiAccordionComponent;

  public POSITION_GROUPED = POSITION_GROUPED;
  public POSITION_LIST = POSITION_LIST;
  public LEVEL_LIST = LEVEL_LIST;
  public POSITION_CATEGORY_LIST = POSITION_CATEGORY_LIST;
  public ADDRESS3_GROUPED = ADDRESS3_GROUPED;
  public ADDRESS3_LIST = ADDRESS3_LIST;

  public countAddressSelected: number = 0;

  public dataSeason: Array<any> = [];
  public arrayPageSeason: Array<any> = [];
  public recordsCountSeason: number = 0;

  private subscriptionaPaginationSeason: Subscription;

  constructor(
    private route: ActivatedRoute,
    private positionIndexPipe: PositionIndexPipe,
    private userService: UserService,
    private jobService: JobService) {
    super();
  }

  ngOnInit() {


    this.createFormGroup();

    this.getQueryParams();

    this.setSubscriptionSearch();

    this.setOptionCategory();

    this.setOptionPosition();

    this.onActionSearch(true);

    this.showUniqueInstitutions = false;
    this.loadPreferences = false;
  }
  getQueryParams() {

    this.route.queryParams.subscribe(params => {

      const paramYear = params['periodo'] || '';

      console.log(paramYear);;
      

      if (paramYear === 'siguiente') {
        this.optionNextSeason.setValue(true, { emitEvent: false });
      }
    });
  }

  private createFormGroup(): void {

    this._formGroupSearch = new UntypedFormGroup({
      optionOrder: new UntypedFormControl('SORT1'),
      optionPosition: this.helpService.getFormArrayGeneric(POSITION_LIST.length),
      optionAddress3: this.helpService.getFormArrayGeneric(ADDRESS3_LIST.length),
      optionFilter: new UntypedFormControl(''),
      optionCategory: this.helpService.getFormArrayGeneric(POSITION_CATEGORY_LIST.length),
      optionLevel: this.helpService.getFormArrayGeneric(LEVEL_LIST.length),
      optionNextSeason: new UntypedFormControl(false),
      optionPage: new UntypedFormControl(1),
      optionPageSeason: new UntypedFormControl(1),
    });
  }

  onClickResetButton(event: MouseEvent): void {
    event.preventDefault();
    this.resetFilters(false);
    this.onActionSearch(true);
  }

  public resetFilters(forceReset: boolean) {

    this.optionOrder.setValue('SORT1', { emitEvent: false });
    this.optionPosition.controls.forEach(e => e.setValue(false, { emitEvent: false }));
    this.optionAddress3.controls.forEach(e => e.setValue(false, { emitEvent: false }));
    this.optionFilter.setValue('', { emitEvent: false });
    if (this.showCategory || forceReset)
      this.optionCategory.controls.forEach(e => e.setValue(false, { emitEvent: false }));
    this.optionLevel.controls.forEach(e => e.setValue(false, { emitEvent: false }));
    this.optionNextSeason.setValue(false, { emitEvent: false });
    this.optionPage.setValue(1, { emitEvent: false });
    this.optionPageSeason.setValue(1, { emitEvent: false });
    this.countAddressSelected = 0;
    this.countFilterTag = 0;
    this.filterAddress3.uncheckOptionAll();
  }

  onActionSearch(isInitSearch: boolean = false) {

    if (!this.platformService.isPlatformBrowser) {
      return;
    }

    if (this.prevRequestSearch === undefined || this.prevRequestSearch !== this._formGroupSearch.getRawValue() || isInitSearch === true) {

      this.prevRequestSearch = this._formGroupSearch.getRawValue();

      this.isLoadingSearch = true;

      var req = this.getRequest();

      setTimeout(() => { this.countFilterTag = document.getElementById("filter-tag-job-form").getElementsByClassName("filter-tag").length; }, 0);

      this.jobService.searchJobCategory(req).toPromise().then(
        (res: any) => {

          if (res?.status_code !== status_code.success) {
            this.setDataError(res?.status_message, undefined)
            return;
          }

          if (this.splitBySeason) {
            this.dataSeason = res['resultsSeason'] !== null ? res['resultsSeason'] : [];
            this.recordsCountSeason = res['recordsCountSeason'];
            this.arrayPageSeason = this.getArrayPagination(this.optionPageSeason.value, res['recordsCountSeason'], res['recordsPerPage']);
          }

          this.data = res['results'] !== null ? res['results'] : [];
          this.recordsCount = res['recordsCount'];
          this.recordsPerPage = res['recordsPerPage'];
          this.arrayPage = this.getArrayPagination(this.optionPage.value, res['recordsCount'], res['recordsPerPage']);
          this.isLoadingSearch = false;
          this.isRequestSuccess = true;
          this.scriptService.initPopover();

          if (Array.isArray(res?.recordsPreferences)) {

            Array.from(res?.recordsPreferences).forEach((el: any) => {

              switch (el.userPreferenceType) {
                case 'optionAddress3':
                  this.setOptionAddress3(el.userPreference);
                  break;
                case 'optionPosition':
                  this.setOptionPosition(el.userPreference);
                  break;
                case 'optionLevel':
                  this.setOptionLevel(el.userPreference);
                  break;
              }

            });

            const _optionAddress3 = this.helpService.getFormArrayGenericTextValues(this.optionAddress3, ADDRESS3_LIST);

            this.countAddressSelected = _optionAddress3?.length > 0 ? _optionAddress3?.length : 0;


            setTimeout(() => { this.countFilterTag = document.getElementById("filter-tag-job-form").getElementsByClassName("filter-tag").length; }, 0);
          }


        },
        err => {
          this.setDataError(err, undefined)
        }

      );
    }

  }

  setSubscriptionSearch() {
    this.subscriptionformGroupSearch = merge(
      this.optionOrder.valueChanges,
      this.optionPosition.valueChanges,
      this.optionAddress3.valueChanges,
      this.optionCategory.valueChanges,
      this.optionLevel.valueChanges,
      this.optionNextSeason.valueChanges,
    ).subscribe(() => {

      this.optionPage.setValue(1, { emitEvent: false });
      this.optionPageSeason.setValue(1, { emitEvent: false });
      this.onActionSearch(false);
    });

    this.subscriptionaPagination = this.optionPage.valueChanges.subscribe(() => {
      this.onActionSearch(false);
    });

    this.subscriptionaPaginationSeason = this.optionPageSeason.valueChanges.subscribe(() => {
      this.onActionSearch(false);
    });
  }

  getRequest() {

    var _optionPosition = this.helpService.getFormArrayGenericTextValues(this.optionPosition, POSITION_LIST);
    var _optionAddress3 = this.helpService.getFormArrayGenericTextValues(this.optionAddress3, ADDRESS3_LIST);
    var _optionCategory = this.helpService.getFormArrayGenericTextValues(this.optionCategory, POSITION_CATEGORY_LIST);
    var _optionLevel = this.helpService.getFormArrayGenericTextValues(this.optionLevel, LEVEL_LIST);

    this.countAddressSelected = _optionAddress3?.length > 0 ? _optionAddress3?.length : 0;

    if (_optionCategory.length > 0) {

      for (let index = 0; index < this.POSITION_GROUPED.length; index++) {
        const element = this.POSITION_GROUPED[index];

        const elementCategory = _optionCategory.find(x => x === element.parent);

        element.enabled = elementCategory ? true : false;

        if (element.enabled === false) {



          for (let index = 0; index < element.items.length; index++) {

            const elementChild = element.items[index];

            const ix = this.positionIndexPipe.transform(elementChild.id);

            if (ix !== -1) {
              this.optionPosition.at(ix).setValue(false, { emitEvent: false })
            }
          }

        }
      }
    }
    else {
      for (let index = 0; index < this.POSITION_GROUPED.length; index++) {
        this.POSITION_GROUPED[index].enabled = true;
      }
    }

    return {
      optionUser: this.userService.isEmployee() ? this.userService.getIdCurrentUser() : undefined,
      optionOrder: this.optionOrder.value,
      optionPosition: _optionPosition,
      optionAddress3: _optionAddress3,
      optionFilter: this.optionFilter.value,
      optionCategory: _optionCategory,
      optionLevel: _optionLevel,
      optionNextSeason: this.optionNextSeason.value === true ? 1 : undefined,
      optionPage: this.optionPage.value,
      optionPageSeason: this.splitBySeason === true ? this.optionPageSeason.value : undefined,
      optionSeason: this.splitBySeason === true ? 1 : undefined,
      optionUniqueInstitution: this.showUniqueInstitutions === true ? 1 : undefined,
      optionPreferences: this.userService.isEmployee() && this.loadPreferences === true && !this.category && !this.position ? 1 : undefined
    }
  }

  changePageSeason(page: any) {
    this.optionPageSeason.setValue(page);
  }

  ngOnDestroy() {
    if (this.subscriptionformGroupSearch) { this.subscriptionformGroupSearch.unsubscribe(); }
    if (this.subscriptionaPagination) { this.subscriptionaPagination.unsubscribe(); }
    if (this.subscriptionaPaginationSeason) { this.subscriptionaPaginationSeason.unsubscribe(); }
  }

  resetOptionAddress() {
    this.optionAddress3.controls.forEach(e => e.setValue(false, { emitEvent: false }));
    this.filterAddress3.uncheckOptionAll();
    this.optionAddress3.updateValueAndValidity();
  }

  setOptionPosition(value: string = undefined) {

    const pos = value || this.position;

    if (!pos)
      return;

    const ix = POSITION_LIST.findIndex(x => x.text === pos);

    if (ix === -1)
      return;

    this.optionPosition.at(ix).setValue(true, { emitEvent: false })
  }

  setOptionCategory(value: string = undefined) {

    const cat = value || this.category;

    if (!cat)
      return;

    const ix = POSITION_CATEGORY_LIST.findIndex(x => x.text === cat);

    if (ix === -1)
      return;

    this.optionCategory.at(ix).setValue(true, { emitEvent: false })
  }

  setOptionAddress3(value: string) {

    if (!value)
      return;

    const ix = this.ADDRESS3_LIST.findIndex(x => x.text === value);

    if (ix === -1)
      return;

    this.optionAddress3.at(ix).setValue(true, { emitEvent: false })
  }


  setOptionLevel(value: string) {

    if (!value)
      return;

    const ix = this.LEVEL_LIST.findIndex(x => x.text === value);

    if (ix === -1)
      return;

    this.optionLevel.at(ix).setValue(true, { emitEvent: false })
  }

  get optionPosition() { return this._formGroupSearch.get('optionPosition') as UntypedFormArray; }
  get optionAddress3() { return this._formGroupSearch.get('optionAddress3') as UntypedFormArray; }
  get optionCategory() { return this._formGroupSearch.get('optionCategory') as UntypedFormArray; }
  get optionLevel() { return this._formGroupSearch.get('optionLevel') as UntypedFormArray; }
  get optionNextSeason() { return this._formGroupSearch.get('optionNextSeason') as UntypedFormControl; }
  get optionPageSeason() { return this._formGroupSearch.get('optionPageSeason') as UntypedFormControl; }
}
